import { Switch, Route, Redirect } from 'react-router-dom';
import { authRoutes } from './allRoutes';

const switchRoutes = (
  <Switch>
    {authRoutes.map((prop, key) => {
      if (prop.layout === 'auth') {
        return <Route path={`/${prop.layout}${prop.path}`} component={prop.component} key={key} exact />;
      }
      return null;
    })}
    <Redirect from="/auth" to="/auth/login" />
  </Switch>
);
const Auth = () => {
  return <>{switchRoutes}</>;
};

export default Auth;
